module.exports = __webpack_public_path__ + "img/maintain-icon5.2c5ceb5d.png";